import { Profile } from "@/models/Profile.model";
import { create } from "zustand";

type UsersState = {
  users: Profile[] | null;
  setUsers: (users: Profile[]) => void;
};

export const useUsersStore = create<UsersState>(
  (set: (partial: Partial<UsersState>) => void) => ({
    users: null,
    setUsers: (newUsers) =>
      set({
        users: newUsers,
      }),
  })
);
